import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import Colors from 'app/types/Colors';
// Components
import Dialog from 'app/components/Dialog';
import ColorPalette from 'app/components/ColorPalette';
import { Button } from 'app/components/Mui';

type Props = {
  open: boolean;
  onClose: (colors?:string[]) => void;
  initialColors?: string[];
  title?: string;
};

const ColorPalettePickerDialog = ({
  // Props
  initialColors = [], open, onClose, title
}:Props) => {
  const { t } = useTranslation();

  const [ colors, setColors ] = useState<string[]>(initialColors);

  const handleColorClick = (newColor:Colors|string) => {
    const newColors = colors.includes(newColor)
      ? colors.filter((color:Colors | string) => color !== newColor)
      : [...colors, newColor]
    ;
    setColors(newColors);
  }

  const handleCloseClick = (withColors:boolean = false) => () => {
    onClose(withColors ? colors : undefined);
  }

  const isLoading = false;

  const actions = (
    <Fragment>
      <Button
        name="Cancel page colors dialog"
        onClick={handleCloseClick()}
      >{t('buttons.close')}</Button>
      <Button
        name="Save page colors dialog"
        onClick={handleCloseClick(true)}
        loading={isLoading}
        variant="contained"
        color="primary"
      >{t('buttons.save')}</Button>
    </Fragment>
  );

  return (
    <Dialog
      open={open}
      onClose={handleCloseClick()}
      maxWidth="sm"
      title={title || t('dialogs.cardPageColors.title')}
      actions={actions}
    >
      <ColorPalette activeColors={colors} showNoColorValue={false}>
        {(color) => (
          <ColorPalette.Item
            key={color}
            color={color}
            onClick={handleColorClick}
          />
        )}
      </ColorPalette>
    </Dialog>
  )
}

export default ColorPalettePickerDialog;
